import Patterns from '../patterns.js';

export default [
  {
    name: 'name.cs',
    label: {
      cs: 'Název [CS]',
      en: 'Name [CS]',
    },
    type: 'string',
    pattern: Patterns.ALPHANUMERIC,
    patternErrorMessage: Patterns.ALPHANUMERIC_MESSAGE,
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'name.en',
    label: {
      cs: 'Název [EN]',
      en: 'Name [EN]',
    },
    type: 'string',
    pattern: Patterns.ALPHANUMERIC,
    patternErrorMessage: Patterns.ALPHANUMERIC_MESSAGE,
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'date',
    label: {
      cs: 'Datum',
      en: 'Date',
    },
    type: 'date',
    required: true,
  },
  {
    name: 'photogallery',
    label: {
      cs: 'Fotogalerie',
      en: 'Photogallery',
    },
    type: 'string',
    pattern: Patterns.ALPHANUMERIC,
    patternErrorMessage: Patterns.ALPHANUMERIC_MESSAGE,
    minLength: 2,
    maxLength: 128,
  },
];
